var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 30,
    viewBox: "0 0 46 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9545 0.0183334C26.6916 0.0183334 23.7757 1.36118 23.7757 3.84219C23.7757 6.68743 28.9472 6.88395 28.9472 8.31333C28.9472 8.91517 28.0785 9.45392 26.5949 9.45392C24.4893 9.45392 22.9156 8.70113 22.9156 8.70113L22.2423 11.2047C22.2423 11.2047 24.0551 11.8406 26.462 11.8406C30.0294 11.8406 32.8365 10.4318 32.8365 7.90841C32.8365 4.9019 27.6435 4.71122 27.6435 3.38452C27.6435 2.91306 28.3566 2.39648 29.836 2.39648C31.5052 2.39648 32.8671 2.94396 32.8671 2.94396L33.5261 0.525899C33.5261 0.525899 32.0442 0.0183334 29.9545 0.0183334ZM0.102018 0.200829L0.0230103 0.56582C0.0230103 0.56582 1.39572 0.765297 2.63207 1.16321C4.22398 1.61949 4.33738 1.88512 4.60548 2.71014L7.52699 11.6524H11.4433L17.4766 0.200829H13.5693L9.69253 7.98683L8.11057 1.38705C7.96549 0.631711 7.23062 0.200829 6.33109 0.200829H0.102018ZM19.0478 0.200829L15.9827 11.6524H19.7086L22.763 0.200829H19.0478ZM39.8287 0.200829C38.9303 0.200829 38.4542 0.582761 38.1049 1.25018L32.6462 11.6524H36.5535L37.3095 9.91872H42.0697L42.5294 11.6524H45.977L42.9693 0.200829H39.8287ZM40.3369 3.2947L41.4951 7.5919H38.3922L40.3369 3.2947Z",
    fill: "#1434CB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.7429 26.9129C40.7429 28.389 39.7126 29.5909 38.4473 29.5909H25.9572V18.9841C25.9572 17.5081 26.9875 16.3061 28.2527 16.3061H40.7429V26.9129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6759 24.1926H37.6249C37.652 24.1926 37.7152 24.1821 37.7424 24.1821C37.9231 24.1399 38.0768 23.9501 38.0768 23.6866C38.0768 23.4335 37.9231 23.2437 37.7424 23.191C37.7152 23.1805 37.661 23.1805 37.6249 23.1805H36.6759V24.1926Z",
    fill: "url(#paint0_linear_1_311)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5164 17.2023C36.6127 17.2023 35.8716 18.0563 35.8716 19.1212V21.1139H38.1943C38.2485 21.1139 38.3117 21.1139 38.3569 21.1245C38.8811 21.1561 39.2697 21.4724 39.2697 22.0207C39.2697 22.453 39.0077 22.822 38.5196 22.8958V22.9169C39.0528 22.9591 39.4595 23.307 39.4595 23.8447C39.4595 24.4246 39.0077 24.8042 38.4112 24.8042H35.8625V28.7053H38.2756C39.1794 28.7053 39.9205 27.8513 39.9205 26.7864V17.2023H37.5164Z",
    fill: "url(#paint1_linear_1_311)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9593 22.1472C37.9593 21.8942 37.8056 21.7255 37.6249 21.6938C37.6068 21.6938 37.5616 21.6833 37.5345 21.6833H36.6759V22.6111H37.5345C37.5616 22.6111 37.6158 22.6111 37.6249 22.6006C37.8056 22.5689 37.9593 22.4002 37.9593 22.1472Z",
    fill: "url(#paint2_linear_1_311)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4244 17.2023C27.5207 17.2023 26.7796 18.0563 26.7796 19.1212V23.8553C27.2405 24.1188 27.7195 24.2875 28.1985 24.2875C28.7679 24.2875 29.0752 23.8869 29.0752 23.3386V21.1034H30.485V23.3281C30.485 24.1926 30.0241 24.8991 28.4606 24.8991C27.5116 24.8991 26.7705 24.6566 26.7705 24.6566V28.6947H29.1836C30.0874 28.6947 30.8285 27.8407 30.8285 26.7758V17.2023H28.4244Z",
    fill: "url(#paint3_linear_1_311)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9704 17.2023C32.0667 17.2023 31.3256 18.0563 31.3256 19.1212V21.6306C31.7413 21.2194 32.4643 20.9558 33.6302 21.019C34.2538 21.0507 34.9226 21.251 34.9226 21.251V22.0629C34.5882 21.8625 34.1905 21.6833 33.6754 21.6411C32.7897 21.5673 32.2564 22.0734 32.2564 22.9591C32.2564 23.8553 32.7897 24.3613 33.6754 24.277C34.1905 24.2348 34.5882 24.045 34.9226 23.8553V24.6671C34.9226 24.6671 34.2628 24.8674 33.6302 24.8991C32.4643 24.9623 31.7413 24.6987 31.3256 24.2875V28.7158H33.7386C34.6424 28.7158 35.3835 27.8618 35.3835 26.7969V17.2023H32.9704Z",
    fill: "url(#paint4_linear_1_311)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1_311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.1156 29.618V28.7326C8.1156 28.394 7.92619 28.1722 7.60104 28.1722C7.43846 28.1722 7.26168 28.2306 7.14015 28.4232C7.04544 28.2616 6.9097 28.1722 6.70608 28.1722C6.57034 28.1722 6.4346 28.2169 6.32727 28.3785V28.2014H6.04315V29.618H6.32727V28.8358C6.32727 28.5848 6.4488 28.4662 6.63821 28.4662C6.82762 28.4662 6.92233 28.5985 6.92233 28.8358V29.618H7.20644V28.8358C7.20644 28.5848 7.34218 28.4662 7.51738 28.4662C7.70679 28.4662 7.8015 28.5985 7.8015 28.8358V29.618H8.1156ZM12.33 28.2014H11.8691V27.7733H11.5849V28.2014H11.3277V28.4816H11.5849V29.1315C11.5849 29.4564 11.7065 29.6473 12.0316 29.6473C12.1532 29.6473 12.2889 29.6026 12.3836 29.5441L12.3015 29.2776C12.2195 29.3361 12.1248 29.3516 12.0569 29.3516C11.9211 29.3516 11.8675 29.2622 11.8675 29.116V28.4816H12.3284V28.2014H12.33ZM14.7418 28.1705C14.5792 28.1705 14.4703 28.2599 14.4024 28.3768V28.1997H14.1183V29.6163H14.4024V28.8186C14.4024 28.5831 14.4971 28.449 14.6739 28.449C14.7276 28.449 14.7954 28.4644 14.8507 28.4782L14.9327 28.1825C14.8759 28.1705 14.7954 28.1705 14.7418 28.1705ZM11.0972 28.3183C10.9615 28.2152 10.7721 28.1705 10.5684 28.1705C10.2433 28.1705 10.0271 28.3475 10.0271 28.6278C10.0271 28.8633 10.1896 28.9974 10.4737 29.0404L10.6095 29.0559C10.7579 29.0851 10.8399 29.1298 10.8399 29.2037C10.8399 29.3069 10.731 29.3808 10.5416 29.3808C10.3522 29.3808 10.2023 29.3069 10.1076 29.2329L9.97181 29.4685C10.1202 29.5871 10.3238 29.6456 10.5274 29.6456C10.9062 29.6456 11.124 29.453 11.124 29.1882C11.124 28.9372 10.9473 28.8049 10.6774 28.7602L10.5416 28.7447C10.4201 28.7292 10.3254 28.7 10.3254 28.6123C10.3254 28.5091 10.4201 28.4507 10.57 28.4507C10.7326 28.4507 10.8952 28.5246 10.9773 28.5693L11.0972 28.3183ZM18.6562 28.1705C18.4936 28.1705 18.3847 28.2599 18.3169 28.3768V28.1997H18.0327V29.6163H18.3169V28.8186C18.3169 28.5831 18.4116 28.449 18.5883 28.449C18.642 28.449 18.7099 28.4644 18.7651 28.4782L18.8472 28.1859C18.792 28.1705 18.7115 28.1705 18.6562 28.1705ZM15.0259 28.9097C15.0259 29.3378 15.2974 29.6473 15.7172 29.6473C15.9066 29.6473 16.0424 29.6026 16.1781 29.4857L16.0424 29.2347C15.9335 29.3241 15.8261 29.367 15.703 29.367C15.4726 29.367 15.31 29.19 15.31 28.9097C15.31 28.6432 15.4726 28.4662 15.703 28.4524C15.8245 28.4524 15.9335 28.4971 16.0424 28.5848L16.1781 28.3338C16.0424 28.2152 15.9066 28.1722 15.7172 28.1722C15.2974 28.1705 15.0259 28.4816 15.0259 28.9097ZM17.6539 28.9097V28.2014H17.3698V28.3785C17.2751 28.2461 17.1394 28.1722 16.9626 28.1722C16.5964 28.1722 16.3123 28.4816 16.3123 28.9097C16.3123 29.3378 16.5964 29.6473 16.9626 29.6473C17.152 29.6473 17.2877 29.5733 17.3698 29.441V29.618H17.6539V28.9097ZM16.6106 28.9097C16.6106 28.6587 16.759 28.4524 17.0036 28.4524C17.2341 28.4524 17.3966 28.645 17.3966 28.9097C17.3966 29.1607 17.2341 29.367 17.0036 29.367C16.7605 29.3516 16.6106 29.159 16.6106 28.9097ZM13.2107 28.1705C12.8319 28.1705 12.5604 28.4662 12.5604 28.908C12.5604 29.3516 12.8319 29.6456 13.2249 29.6456C13.4143 29.6456 13.6037 29.5871 13.7537 29.453L13.6179 29.2312C13.509 29.3206 13.3733 29.3791 13.2391 29.3791C13.0623 29.3791 12.8871 29.2897 12.8461 29.0404H13.8073C13.8073 28.9957 13.8073 28.9665 13.8073 28.9218C13.82 28.4662 13.5753 28.1705 13.2107 28.1705ZM13.2107 28.4369C13.3875 28.4369 13.509 28.5556 13.5359 28.7756H12.8587C12.8856 28.5848 13.0071 28.4369 13.2107 28.4369ZM20.2693 28.9097V27.6409H19.9852V28.3785C19.8905 28.2461 19.7548 28.1722 19.578 28.1722C19.2118 28.1722 18.9277 28.4816 18.9277 28.9097C18.9277 29.3378 19.2118 29.6473 19.578 29.6473C19.7674 29.6473 19.9032 29.5733 19.9852 29.441V29.618H20.2693V28.9097ZM19.226 28.9097C19.226 28.6587 19.3744 28.4524 19.619 28.4524C19.8495 28.4524 20.0121 28.645 20.0121 28.9097C20.0121 29.1607 19.8495 29.367 19.619 29.367C19.3744 29.3516 19.226 29.159 19.226 28.9097ZM9.71453 28.9097V28.2014H9.43042V28.3785C9.33571 28.2461 9.19997 28.1722 9.02319 28.1722C8.657 28.1722 8.37288 28.4816 8.37288 28.9097C8.37288 29.3378 8.657 29.6473 9.02319 29.6473C9.2126 29.6473 9.34834 29.5733 9.43042 29.441V29.618H9.71453V28.9097ZM8.65857 28.9097C8.65857 28.6587 8.80694 28.4524 9.0516 28.4524C9.28205 28.4524 9.44462 28.645 9.44462 28.9097C9.44462 29.1607 9.28205 29.367 9.0516 29.367C8.80694 29.3516 8.65857 29.159 8.65857 28.9097Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2705 17.4425H11.0025V25.7945H15.2705V17.4425Z",
    fill: "#FF5A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2866 21.6185C11.2866 19.9216 12.019 18.4156 13.1428 17.4425C12.3158 16.7342 11.2724 16.3061 10.1344 16.3061C7.43847 16.3061 5.25711 18.6821 5.25711 21.6185C5.25711 24.5549 7.43847 26.9309 10.1344 26.9309C11.2724 26.9309 12.3158 26.5028 13.1428 25.7945C12.0174 24.8352 11.2866 23.3154 11.2866 21.6185Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0285 21.6185C21.0285 24.5549 18.8472 26.9309 16.1513 26.9309C15.0132 26.9309 13.9699 26.5028 13.1428 25.7945C14.2809 24.8197 14.999 23.3154 14.999 21.6185C14.999 19.9216 14.2666 18.4156 13.1428 17.4425C13.9683 16.7342 15.0117 16.3061 16.1497 16.3061C18.8472 16.3061 21.0285 18.6975 21.0285 21.6185Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_311",
    x1: 35.87,
    y1: 23.6878,
    x2: 39.9314,
    y2: 23.6878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_311",
    x1: 35.8699,
    y1: 22.9492,
    x2: 39.9316,
    y2: 22.9492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_311",
    x1: 35.8699,
    y1: 22.1459,
    x2: 39.9314,
    y2: 22.1459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_311",
    x1: 26.7777,
    y1: 22.9492,
    x2: 30.9019,
    y2: 22.9492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_311",
    x1: 31.3022,
    y1: 22.9492,
    x2: 35.3077,
    y2: 22.9492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 11.8588,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.7857,
    height: 13.3412,
    fill: "white",
    transform: "translate(25.9572 16.3061)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1_311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.7715,
    height: 13.3412,
    fill: "white",
    transform: "translate(5.25711 16.3061)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaMasterCard);
export default __webpack_public_path__ + "static/media/visa-master-card.51d23fa85496d3b9637fa237433949ce.svg";
export { ForwardRef as ReactComponent };